import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { CurrencyInput } from '../../../../../../../../../CurrencyInput'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

interface InvoiceSubtotalExcludingVatProps extends CommonInvoiceLineFieldProps {
  columnIndex: number
}

export const InvoiceSubtotalExcludingVat = ({
  disabled = false,
  lineIndex,
  columnIndex,
}: InvoiceSubtotalExcludingVatProps) => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm
  const columnPlacementIndex = columnIndex + 1

  return (
    <FormItem
      itemColumnStart={columnPlacementIndex}
      name={`invoiceLines.${lineIndex}.subtotalExcludingVat`}
      render={({ field: { value, onChange, ...props } }) => {
        return <CurrencyInput {...props} disabled={disabled} onChange={onChange} readOnly value={value} />
      }}
    />
  )
}
